// extracted by mini-css-extract-plugin
export default {"card":"PY-z","carouselContainer":"QY-z","carouselContent":"RY-z"};